import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";

type ApprovalList = { items: ShiftProductionFormListItem[]; total: number };

/** Read bounded API batches, then expose one complete list to the screen. */
export async function loadApprovalFormPages(
  loadBatch: (offset: number) => Promise<ApprovalList>,
  isCurrent: () => boolean = () => true,
): Promise<ApprovalList | null> {
  const items: ShiftProductionFormListItem[] = [];
  let expectedTotal: number | null = null;
  do {
    const batch = await loadBatch(items.length);
    if (!isCurrent()) return null;
    if (expectedTotal !== null && batch.total !== expectedTotal) {
      throw new Error("Onay listesi yüklenirken değişti. Tekrar deneyin.");
    }
    expectedTotal = batch.total;
    if (!batch.items.length && items.length < expectedTotal) {
      throw new Error("Onayların tamamı yüklenemedi. Tekrar deneyin.");
    }
    items.push(...batch.items);
  } while (items.length < expectedTotal);
  if (items.length !== expectedTotal || new Set(items.map(item => item.id)).size !== expectedTotal) {
    throw new Error("Onay listesi yüklenirken değişti. Tekrar deneyin.");
  }
  return { items, total: expectedTotal };
}
